import Repository from "../axios";
import { defaultPagination } from "@/constants/config";

const resource = "/admin/system_setting";
export default {
  getTollDryingSizesList(
    pageNumber = 1,
    filterQuery,
    pagination = defaultPagination,
    sort
  ) {
    return Repository.get(
      `${resource}/toll-drying-sizes?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`
    );
  },
  getListNoPagination() {
    return Repository.get(`${resource}/toll-drying-sizes?is_paginate=0`);
  },
  getTollDryingSizeDetails(id) {
    return Repository.get(`${resource}/toll-drying-sizes/${id}`);
  },
  updateTollDryingSize(id, payload) {
    return Repository.put(`${resource}/toll-drying-sizes/${id}`, payload);
  },
  createTollDryingSize(payload) {
    return Repository.post(`${resource}/toll-drying-sizes`, payload);
  },

  getTollDryingYieldRangesList(
    pageNumber = 1,
    filterQuery,
    pagination = defaultPagination,
    sort
  ) {
    return Repository.get(
      `${resource}/toll-drying-costs?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`
    );
  },

  createOrUpdateRanges(payload) {
    return Repository.post(`${resource}/toll-drying-costs`, payload);
  },

  getTollDryingYieldRangeDetails(id) {
    return Repository.get(`${resource}/toll-drying-costs/${id}`);
  },

  getSprayDryCarriersList(
    pageNumber = 1,
    filterQuery,
    pagination = defaultPagination,
    sort
  ) {
    return Repository.get(
      `${resource}/spray-dry-carriers?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`
    );
  },

  createSprayDryCarrier(payload) {
    return Repository.post(`${resource}/spray-dry-carriers`, payload);
  },

  updateSprayDryCarrier(id, payload) {
    return Repository.put(`${resource}/spray-dry-carriers/${id}`, payload);
  },

  getSprayDryCarrierDetails(id) {
    return Repository.get(`${resource}/spray-dry-carriers/${id}`);
  },

  getSprayDrySundryList(
    pageNumber = 1,
    filterQuery,
    pagination = defaultPagination,
    sort
  ) {
    return Repository.get(
      `${resource}/toll-drying-sundries?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`
    );
  },

  getSprayDrySundryDetails(id) {
    return Repository.get(`${resource}/toll-drying-sundries/${id}`);
  },

  createSprayDrySundry(payload) {
    return Repository.post(`${resource}/toll-drying-sundries`, payload);
  },

  updateSprayDrySundry(id, payload) {
    return Repository.put(`${resource}/toll-drying-sundries/${id}`, payload);
  },

  getSprayDrySundryCostsList(
    id,
    pageNumber = 1,
    filterQuery,
    pagination = defaultPagination,
    sort
  ) {
    return Repository.get(
      `${resource}/toll-drying-sundries/${id}/costs?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`
    );
  },

  createOrUpdateSprayDrySundryCosts(id, payload) {
    return Repository.post(
      `${resource}/toll-drying-sundries/${id}/costs`,
      payload
    );
  },

  // toll drying min charge settings

  updateTollDryingCostSettings(payload) {
    return Repository.post(`${resource}/toll-drying-cost-settings`, payload)
  },

  getTollDryingCostSettings() {
    return Repository.get(`${resource}/toll-drying-cost-settings`)
  }

};
